import { put, takeLatest } from "redux-saga/effects";
import { actionTypes as authActionTypes } from "../../Auth/_redux/authRedux";
export const actionTypes = {
  setVariable: "[reserve] setVariable Action",
  changeBackPanel: "[reserve] ChangeBackPanel Action",
  travelDetailsLoaded: "[reserve] travelDetailsLoaded Action",
  reservedSeatsChanged: "[reserve] reservedSeatsChanged Action",
  preReserveCompleted: "[reserve] preReserveCompleted Action",
  discountApplied: "[reserve] discountApplied Action",
  paymentCompleted: "[reserve] paymentCompleted Action",

  sendMessage: "[reserve] sendMessage Action",
  hideMessage: "[reserve] hideMessage Action",
  mockType: "[mockType] action",
  loadTravels: "[reserve] loadTravels Action",
  serverError: "[reserve] serverError Action",
  waitingForServer: "[reserve] waitingForServer Action",
  seatInfoCompleted: "[reserve] seatInfoCompleted Action",
  changeFavoritePassengerModal: "[reserve] changeFavoritePassengerModal Action",
  favoritePassengersLoaded: "[reserve] favoritePassengersLoaded Action",
  setPassengers: "[reserve] setPassengers Action",
  openSeatChoose: "[reserve] openSeatChoose Action",
  loadingStats: "[reserve] loadingStats Actions",
  tabsDate: "[reserve] tabsState Actions",
  firstTabsDate: "[firstTabsDate] tabsState Actions",
};

export const initialReserveState = {
  needs_login: false,
  reserved: [],
  openDrawer: false,
  // trip_price: null,
  total_amount: 0,
  total_price: 0,
  discounted_amount: 0,
  payment_info: null,
  snackOpen: false,
  snackMessage: "",
  snackType: "warning",
  passengers: [],
  activeStep: 1,

  // ticket_ids: [741,742],
  travel_details: [],
  current_travel: null,

  seat_choose_open: false,
  seat_choose_right: 0,
  seat_choose_top: 0,
  current_seatNumber: null,

  is_all_seats_selected: false,
  ticket_ids: [],
  show_payment_methods: false,
  discount_code: "",
  is_results_ready: false,
  waiting_for_server: false,
  seat_info_completed: false,
  ticket_details: [],
  show_favorite_passengers: false,
  current_selected_passenger: null,
  favorite_passengers: [],
  mockTravels: [],
  loadingStats: undefined,
  tabsDate: undefined,
  firstTabsDate: undefined,
};

export const reducer = (state = initialReserveState, action) => {
  switch (action.type) {
    case actionTypes.setVariable: {
      const varName = action.varName;
      let prp = { ...state };
      prp[varName] = action.payload;
      return prp;
    }
    case authActionTypes.loginSucceeded: {
      return { ...state, needs_login: false };
    }
    case actionTypes.tabsDate: {
      return { ...state, tabsDate: action.payload };
    }
    case actionTypes.travelDetailsLoaded: {
      return {
        ...state,
        travel_details: action.payload,
        is_results_ready: true,
      };
    }
    case actionTypes.reservedSeatsChanged: {
      return { ...state, reserved: action.payload };
    }
    case actionTypes.loadingStats: {
      return { ...state, loadingStats: action.payload };
    }
    case actionTypes.firstTabsDate: {
      return { ...state, firstTabsDate: action.payload };
    }
    case actionTypes.serverError: {
      return { ...state, is_results_ready: true, server_error: true };
    }
    case actionTypes.sendMessage: {
      return {
        ...state,
        snackOpen: true,
        snackMessage: action.message,
        snackType: action.message_type,
      };
    }
    case actionTypes.hideMessage: {
      return { ...state, snackOpen: false };
    }
    case actionTypes.preReserveCompleted: {
      return { ...state, ticket_ids: action.payload, activeStep: 2 };
    }
    case actionTypes.mockType: {
      return { ...state, mockTravels: action.payload };
    }
    case actionTypes.discountApplied: {
      return {
        ...state,
        total_price: action.payload,
        total_amount: action.total,
      };
    }
    case actionTypes.paymentCompleted: {
      return {
        ...state,
        activeStep: 4,
        snackOpen: true,
        snackMessage: action.message,
        snackType: "success",
      };
    }
    case actionTypes.waitingForServer: {
      return { ...state, waiting_for_server: action.payload };
    }
    case actionTypes.seatInfoCompleted: {
      return {
        ...state,
        seat_info_completed: true,
        ticket_details: action.payload,
      };
    }
    case actionTypes.changeFavoritePassengerModal: {
      return {
        ...state,
        show_favorite_passengers: action.payload,
        current_selected_passenger: action.seat_id,
      };
    }
    case actionTypes.favoritePassengersLoaded: {
      return { ...state, favorite_passengers: action.payload };
    }
    case actionTypes.setPassengers: {
      return { ...state, passengers: action.payload };
    }
    case actionTypes.openSeatChoose: {
      return {
        ...state,
        current_seatNumber:
          action.seatNumber === undefined ? 0 : action.seatNumber,
        seat_choose_open: action.payload,
        seat_choose_right: action.right === undefined ? 0 : action.right,
        seat_choose_top: action.top === undefined ? 0 : action.top,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  handle_variables: (varName, value) => ({
    type: actionTypes.setVariable,
    varName: varName,
    payload: value,
  }),
  change_backPanel: (state) => ({
    type: actionTypes.changeBackPanel,
    payload: state,
  }),
  travel_details_loaded: (data) => ({
    type: actionTypes.travelDetailsLoaded,
    payload: data,
  }),
  sendMessage: (message, type) => ({
    type: actionTypes.sendMessage,
    message: message,
    message_type: type,
  }),
  hideMessage: () => ({ type: actionTypes.hideMessage }),
  pre_reserve_completed: (data) => ({
    type: actionTypes.preReserveCompleted,
    payload: data,
  }),
  discount_applied: (total, data) => ({
    type: actionTypes.discountApplied,
    total: total,
    payload: data,
  }),
  payment_completed: (message) => ({
    type: actionTypes.paymentCompleted,
    message: message,
  }),
  waitingForServer: (data) => ({
    type: actionTypes.waitingForServer,
    payload: data,
  }),
  completed_seat_info: (data) => ({
    type: actionTypes.seatInfoCompleted,
    payload: data,
  }),
  show_passengers_panel: (status, seat_id) => ({
    type: actionTypes.changeFavoritePassengerModal,
    payload: status,
    seat_id: seat_id,
  }),
  favorite_passengers_loaded: (data) => ({
    type: actionTypes.favoritePassengersLoaded,
    payload: data,
  }),
  set_passengers: (data) => ({
    type: actionTypes.setPassengers,
    payload: data,
  }),
  open_seat_choose: (seatNumber, right, top) => ({
    type: actionTypes.openSeatChoose,
    payload: true,
    seatNumber: seatNumber,
    right: right,
    top: top,
  }),
  close_seat_choose: () => ({
    type: actionTypes.openSeatChoose,
    payload: false,
  }),
  serverErrorOccurred: (date) => ({
    type: actionTypes.serverError,
    payload: date,
  }),
  setMockTravels: (payload) => ({
    type: actionTypes.mockType,
    payload,
  }),
  setLoadingStats: (payload) => ({ type: actionTypes.loadingStats, payload }),
  setTabsDate: (payload) => ({ type: actionTypes.tabsDate, payload }),
  setFirstTabsDate: (payload) => ({ type: actionTypes.firstTabsDate, payload }),
};

export function* saga() {
  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //     const {data: user} = yield getUserByToken();
  //
  //     yield put(actions.fulfillUser(user));
  // });
}
